export const Spinner = () => {
	return (
		<div className="container-loader">
			<div className="app-loading">
				<div className="app-loading-spinners">
					<div className="spinner-grow" role="status">
						<span className="sr-only">Loading...</span>
					</div>
					<div className="spinner-grow" role="status">
						<span className="sr-only">Loading...</span>
					</div>
					<div className="spinner-grow" role="status">
						<span className="sr-only">Loading...</span>
					</div>
					<div className="spinner-grow" role="status">
						<span className="sr-only">Loading...</span>
					</div>
					<div className="spinner-grow" role="status">
						<span className="sr-only">Loading...</span>
					</div>
				</div>
			</div>
		</div>
	);
};
